let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gr1Hg")).then(() => parcelRequire('2gvJk'));